import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { Protocol } from '@lib/protocols/data-access';
import { TranslatePipe } from '@ngx-translate/core';

import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'protocols-list-row',
  standalone: true,
  imports: [MatIcon, TranslatePipe],
  templateUrl: './protocol-list-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProtocolListRowComponent {
  readonly protocol = input.required<Protocol>();
  readonly open = output<void>();
  readonly toggleEnabled = output<boolean>();
  readonly deleteProtocol = output<void>();

  protected readonly identifiers = computed(() =>
    this.protocol()
      .identifiers.map(id => [id.icd10Code, id.icpcCode].filter(Boolean).join(' / '))
      .filter(Boolean)
  );

  protected onToggle(event: Event): void {
    event.stopPropagation();
    this.toggleEnabled.emit((event.target as HTMLInputElement).checked);
  }

  protected onDelete(event: Event): void {
    event.stopPropagation();
    this.deleteProtocol.emit();
  }
}
